/* ── NWAhype custom theme JS — loaded with defer, safe to run after parse ── */

/* ── 1. Menu drawer: keep first deep item open on init ── */
(function initDrawer() {
  var firstDeepItem = document.querySelector('.menu-drawer__list-item--deep details');
  if (!firstDeepItem) return;

  var isInitialized = false;
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'open' &&
        !firstDeepItem.hasAttribute('open') &&
        !isInitialized
      ) {
        firstDeepItem.setAttribute('open', '');
      }
    });
  });
  observer.observe(firstDeepItem, { attributes: true });
  firstDeepItem.setAttribute('open', '');
  setTimeout(function() { isInitialized = true; observer.disconnect(); }, 1000);
})();

/* ── 2. External filter link → trigger collsh filter drawer ── */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.openfiltercollection').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var btn = document.querySelector('.collsh__filter-icon-btn');
      if (btn) {
        btn.click();
      } else {
        var drawer = document.querySelector('[class*="collsh-cg__filter-drawer-"]');
        var overlay = document.querySelector('[class*="collsh-cg__filter-overlay-"]');
        if (drawer && overlay) {
          drawer.classList.add('open');
          overlay.classList.add('active');
          document.body.style.overflow = 'hidden';
        }
      }
    });
  });
});

/* ── 3. Wishlist ── */
(function() {
  'use strict';
  var STORAGE_KEY = 'collsh_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }
  function saveWishlist(list) { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
  function isWishlisted(handle) { return getWishlist().indexOf(handle) !== -1; }
  function toggleWishlist(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) { list.push(handle); } else { list.splice(idx, 1); }
    saveWishlist(list);
    return idx === -1;
  }

  function setHeartFilled(btn, filled) {
    var svg = btn.querySelector('svg');
    if (!svg) return;
    svg.style.fill = filled ? '#D02E2E' : 'none';
    svg.style.stroke = filled ? '#D02E2E' : '#1E1E1E';
    svg.querySelectorAll('path').forEach(function(p) {
      p.style.fill = filled ? '#D02E2E' : '';
    });
    btn.setAttribute('data-wishlisted', filled ? 'true' : 'false');
    btn.setAttribute('aria-label', filled ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function syncAllButtons(handle, filled) {
    document.querySelectorAll('.collsh__card').forEach(function(card) {
      var qBtn = card.querySelector('.collsh__card-quickbtn');
      var heart = card.querySelector('.collsh__card-heart');
      if (!qBtn || !heart) return;
      if (qBtn.getAttribute('data-handle') === handle) setHeartFilled(heart, filled);
    });
    document.querySelectorAll('.collsh__card-heart[data-handle]').forEach(function(btn) {
      if (btn.getAttribute('data-handle') === handle) setHeartFilled(btn, filled);
    });
    document.querySelectorAll('.whishsh[data-handle]').forEach(function(btn) {
      if (btn.getAttribute('data-handle') === handle) setHeartFilled(btn, filled);
    });
  }

  function initHearts() {
    document.querySelectorAll('.collsh__card').forEach(function(card) {
      var qBtn = card.querySelector('.collsh__card-quickbtn');
      var heart = card.querySelector('.collsh__card-heart');
      if (!qBtn || !heart) return;
      var handle = qBtn.getAttribute('data-handle');
      if (handle) setHeartFilled(heart, isWishlisted(handle));
    });
    document.querySelectorAll('.whishsh').forEach(function(btn) {
      var handle = btn.getAttribute('data-handle');
      if (handle) setHeartFilled(btn, isWishlisted(handle));
    });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.collsh__card-heart, .whishsh');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    if (!handle) {
      var card = btn.closest('.collsh__card');
      if (!card) return;
      var qBtn = card.querySelector('.collsh__card-quickbtn');
      if (!qBtn) return;
      handle = qBtn.getAttribute('data-handle');
    }
    if (!handle) return;
    var nowAdded = toggleWishlist(handle);
    syncAllButtons(handle, nowAdded);
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
    btn.style.transform = 'scale(1.35)';
    setTimeout(function() { btn.style.transform = ''; }, 200);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHearts);
  } else {
    initHearts();
  }
  document.addEventListener('shopify:section:load', initHearts);
})();

/* ── 4. Cart count sync on drawer close ── */
function updateCartCount(onComplete) {
  document.dispatchEvent(new CustomEvent('cart:update', {
    bubbles: true,
    detail: { data: { source: 'product-form-component' } }
  }));
  if (onComplete) onComplete();
}

document.addEventListener('click', function(e) {
  var target = e.target;
  if (target.classList.contains('cart-drawer__close-button') || target.closest('.cart-drawer__close-button')) {
    updateCartCount();
  }
  if (target.classList.contains('dialog-modal')) {
    var rect = target.getBoundingClientRect();
    var inside = e.clientX >= rect.left && e.clientX <= rect.right &&
                 e.clientY >= rect.top && e.clientY <= rect.bottom;
    if (!inside) updateCartCount();
  }
});

/* ── 5. Cart badge count — single unified polling handler ── */
document.addEventListener('click', function(e) {
  if (!e.target.closest('.add-to-cart-button') &&
      !e.target.closest('#rebuy-cart-close') &&
      !e.target.closest('.rebuy-cart__background')) return;

  var currentCount = parseInt(document.querySelector('.collsh-cart-count')?.textContent) || 0;
  var attempts = 0;

  function pollCart() {
    attempts++;
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        if (cart.item_count !== currentCount || attempts >= 10) {
          document.querySelectorAll('.collsh-cart-count').forEach(function(el) {
            el.textContent = cart.item_count;
          });
        } else {
          setTimeout(pollCart, 1000);
        }
      });
  }
  setTimeout(pollCart, 800);
});

/* ── 6. Rebuy select: out-of-stock option styling ── */
(function() {
  function applyOutOfStockStyling(select) {
    var variantIds = Array.from(select.querySelectorAll('option'))
      .map(function(o) { return o.value; }).filter(Boolean);

    variantIds.forEach(function(variantId) {
      fetch('/variants/' + variantId + '.js')
        .then(function(r) { return r.json(); })
        .then(function(variant) {
          var option = select.querySelector('option[value="' + variantId + '"]');
          if (!option) return;
          if (!variant.available) {
            option.setAttribute('data-sold-out', 'true');
            option.textContent = option.textContent.replace(' - Sold Out', '') + ' - Sold Out';
            option.classList.add('sold-out-option');
          }
        });
    });
  }

  function handleSelectChange(select) {
    select.addEventListener('change', function() {
      var selectedOption = select.options[select.selectedIndex];
      var stockLabel = document.querySelector('.rebuy-modal__product-stock-label');
      var stockContainer = document.querySelector('.rebuy-modal__product-stock');
      var soldOut = selectedOption && selectedOption.getAttribute('data-sold-out') === 'true';
      if (stockLabel) stockLabel.textContent = soldOut ? 'Sold Out' : 'In Stock';
      if (stockContainer) {
        stockContainer.classList.toggle('in-stock', !soldOut);
        stockContainer.classList.toggle('out-of-stock', soldOut);
      }
    });
  }

  function initRebuySelect(select) {
    if (select.dataset.rebuyInitialized) return;
    select.dataset.rebuyInitialized = 'true';
    applyOutOfStockStyling(select);
    handleSelectChange(select);
  }

  var rebuyObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.querySelectorAll) node.querySelectorAll('.rebuy-select').forEach(initRebuySelect);
        if (node.classList && node.classList.contains('rebuy-select')) initRebuySelect(node);
      });
    });
  });
  rebuyObserver.observe(document.body, { childList: true, subtree: true });
})();

/* ── 7. Mobile nav: custom cart trigger ── */
document.addEventListener('DOMContentLoaded', function() {
  var trigger = document.getElementById('custom-cart-trigger');
  if (!trigger) return;
  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    var menuDrawer = document.getElementById('Details-menu-drawer-container');
    if (menuDrawer) {
      menuDrawer.classList.remove('menu-open');
      menuDrawer.removeAttribute('open');
    }
    var nativeCartLink = document.querySelector([
      'a[href="/cart"]:not(#custom-cart-trigger)',
      '[data-cart-toggle]',
      '[aria-controls="cart-drawer"]',
      '#cart-icon-bubble'
    ].join(', '));
    if (nativeCartLink) nativeCartLink.click();
  });
});

/* ── 8. Bottom-nav chat button → Shopify Inbox ──
   Was wired to Gorgias. Gorgias is now contact-page only (Helpsection.liquid and
   locshcta.liquid keep their own Gorgias triggers); Inbox handles sales/product
   chat from the mobile nav, the mobile drawer and the header icon.
   __nwaOpenInbox is defined in sections/headersh.liquid. It returns false while
   Inbox is unavailable, so this stays inert rather than erroring. */
document.addEventListener('DOMContentLoaded', function () {
  var chatBtn = document.getElementById('openchatbtn');
  if (!chatBtn) return;

  chatBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (typeof window.__nwaOpenInbox !== 'function') return;
    if (window.__nwaOpenInbox()) return;
    var tries = 0;
    var t = setInterval(function () {
      if (window.__nwaOpenInbox() || ++tries > 20) clearInterval(t);
    }, 150);
  });
});

/* ── 9. Rebuy search drawer trigger ──
   Deliberately no handler here. Rebuy binds its own click listener to
   .nwa-rebuy-search-open and opens the drawer itself; there is no public
   open()/toggle() on window.Rebuy.SmartSearch to call (it is a bag of render
   helpers, not a controller). An earlier version polled for SmartSearch.open
   and redirected to /search on timeout — since that check could never pass, it
   fired on every search click and dumped shoppers on a blank results page a few
   seconds after they opened the drawer. Do not reintroduce a timer that
   navigates; the trigger is a <button> with no href, so leaving it alone is
   correct and safe. */
